/**
 * STAGE 3 齿轮·机械 —— 激光 + 定时链弹 + 弹幕墙。
 * 小兵射型：滑轨折线狙（ship1）/ 激光束（ship2）/ 定时链弹 + 环（ship3）。
 */
import * as P from '../../game/patterns.js';
import { aimOf, fireTimer, chainVolley, kinkBullet, s3Mid, s3Big } from './bosses.js';

const DROP_STD = [{ type: 'P', weight: 2 }, { type: 'POINT', weight: 3 }]; // P 占比 40%
const DROP_POINT = [{ type: 'POINT', weight: 1 }];
const DROP_ELITE = [{ type: 'B', weight: 1 }, { type: 'STAR', weight: 1 }, { type: 'P', weight: 2 }]; // 精英必掉半数为 P

/** 侦察舰：直线高速 + 单狙 */
function ship1(x, y, vx, vy) {
  return {
    x, y, hp: 12, r: 12, spriteKey: 's3_ship1', scoreValue: 200, drops: DROP_STD,
    script(e, dt, ctx) {
      e.x += vx * dt * 60;
      e.y += vy * dt * 60;
      if (e.y > 8 && e.y < 340 && fireTimer(e, dt, 1.7)) {
        // 滑轨折线狙：飞出 0.8s 后 90° 折向（逐弹交替左右，流水线换轨）
        P.aimed(ctx.field, e.x, e.y, e.age, aimOf(ctx, e.x, e.y), { n: 1, speed: 2.6, color: 'orb_red', onUpdate: kinkBullet(0.8, Math.PI / 2, true) });
      }
    },
  };
}

/** 炮舰：纵队慢压 + 激光束 */
function ship2(x, y, vy) {
  return {
    x, y, hp: 16, r: 13, spriteKey: 's3_ship2', scoreValue: 300, drops: DROP_POINT,
    script(e, dt, ctx) {
      e.y += vy * dt * 60;
      if (e.y > 8 && e.y < 320 && fireTimer(e, dt, 2.4)) {
        P.laserFan(ctx.field, e.x, e.y, e.age, aimOf(ctx, e.x, e.y), { n: 1, speed: 1.6, color: 'orb_red' });
      }
    },
  };
}

/** 重装舰精英：悬停定时链弹 + 离场环 */
function ship3(x) {
  return {
    x, y: -28, hp: 26, r: 15, spriteKey: 's3_ship3', scoreValue: 500, drops: DROP_ELITE,
    script(e, dt, ctx) {
      if (e.y < 130) {
        e.y += 1.6 * dt * 60;
      } else if ((e._hold = (e._hold || 0) + dt) < 4) {
        if (fireTimer(e, dt, 1.8)) {
          chainVolley(ctx.field, e.x, e.y, aimOf(ctx, e.x, e.y), { n: 3, arc: 0.5, speed: 3.0 });
        }
        if (fireTimer(e, dt, 2.6, '_ft2')) {
          P.ring(ctx.field, e.x, e.y, e.age, 0, { n: 10, speed: 1.8, offset: e.age, color: 'pill_blue' });
        }
      } else {
        e.y += 2.4 * dt * 60;
      }
    },
  };
}

export default {
  id: 3, name: '齿轮·机械', bg: 'bg3', bgm: 'stage3',
  *script(api) {
    const W = api.VIEW_W;
    yield { say: 'STAGE 3  齿轮·机械' };
    yield { wait: 1.0 };

    // W1 侦察舰纵队
    yield { wave: [0, 1, 2, 3].map((i) => ship1(W / 2, -24 - i * 42, 0, 2.0)) };
    yield { wait: 4.0 };
    // W2 交叉编队
    yield {
      wave: [
        ...[0, 1, 2].map((i) => ship1(50 + i * 40, -24 - i * 34, 1.2, 1.6)),
        ...[0, 1, 2].map((i) => ship1(W - 50 - i * 40, -24 - i * 34, -1.2, 1.6)),
      ],
    };
    yield { wait: 4.0 };
    // W3 炮舰纵队（激光封线）
    yield { wave: [0, 1, 2].map((i) => ship2(120 + i * 120, -24, 1.1)) };
    yield { wait: 4.5 };
    // W4 精英重装舰
    yield { wave: [ship3(W / 2)] };
    yield { clear: true };
    yield { wait: 1.0 };

    yield { boss: s3Mid() };
    yield { wait: 2.0 };

    // W5 包夹（道中二，强度上升）
    yield {
      wave: [
        ...[0, 1, 2].map((i) => ship1(-20, 80 + i * 44, 1.8, 0.5)),
        ...[0, 1, 2].map((i) => ship1(W + 20, 100 + i * 44, -1.8, 0.5)),
      ],
    };
    yield { wait: 4.0 };
    // W6 炮舰 + 侦察混编
    yield {
      wave: [
        ...[0, 1].map((i) => ship2(150 + i * 180, -24, 1.2)),
        ...[0, 1, 2].map((i) => ship1(90 + i * 150, -70, 0, 2.2)),
      ],
    };
    yield { wait: 4.0 };
    // W7 双重装
    yield { wave: [ship3(130), ship3(W - 130)] };
    yield { clear: true };
    yield { wait: 1.0 };

    yield { boss: s3Big() };
    yield { say: 'STAGE 3 CLEAR' };
  },
};
